// extracted by mini-css-extract-plugin
module.exports = {"section":"MarketingSection_section__9jl07"};